webpackJsonp([10],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _NewMenuv = __webpack_require__(653);

var _NewMenuv2 = _interopRequireDefault(_NewMenuv);

var _NewFooterV = __webpack_require__(544);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _PromoBannerCTA = __webpack_require__(737);

var _PromoBannerCTA2 = _interopRequireDefault(_PromoBannerCTA);

var _TwoColumnAccordionWithImage = __webpack_require__(739);

var _TwoColumnAccordionWithImage2 = _interopRequireDefault(_TwoColumnAccordionWithImage);

var _GenericFAQ = __webpack_require__(741);

var _GenericFAQ2 = _interopRequireDefault(_GenericFAQ);

var _TestimonialVideoCards = __webpack_require__(594);

var _TestimonialVideoCards2 = _interopRequireDefault(_TestimonialVideoCards);

var _HeroRatings = __webpack_require__(621);

var _HeroRatings2 = _interopRequireDefault(_HeroRatings);

var _TrustedByCompanies = __webpack_require__(743);

var _TrustedByCompanies2 = _interopRequireDefault(_TrustedByCompanies);

__webpack_require__(745);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "O recurso está disponível para todos os planos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Sim! É possível realizar 5 usos por mês/por usuário sem custos nos planos Bronze e Prata (indústrias e distribuidoras) e Básico e Intermediário (representantes). O recurso é ilimitado nos planos Ouro (indústrias e distribuidoras) e Corporativo (representantes)."
    }
  }, {
    "@type": "Question",
    "name": "O recurso é gratuito?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Sim, o recurso é gratuito para qualquer plano contratado no Mercos, com limite de 5 usos por mês/usuário nos planos Bronze, Prata, Básico e Intermediário. O recurso é ilimitado nos planos Ouro e Corporativo. Basta acessar a aba de Pedidos, clicar em “Criar pedido / orçamento” e começar a aproveitar a agilidade e eficiência dos Pedidos com IA."
    }
  }, {
    "@type": "Question",
    "name": "O recurso atende somente mensagens recebidas por WhatsApp ou outras ferramentas de comunicação?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "O Pedidos com IA funciona com qualquer tipo de conteúdo enviado pelo cliente, seja ele vindo do WhatsApp, e-mail, Telegram, mensagem de voz ou até anotações feitas manualmente. Você só precisa copiar a mensagem ou enviar o arquivo no sistema Mercos — a IA interpreta e transforma tudo isso em um pedido para revisar e finalizar."
    }
  }, {
    "@type": "Question",
    "name": "Posso usar o sistema de pedidos com IA em qualquer dispositivo?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "O Sistema de Pedidos com IA funciona em dispositivos com acesso ao sistema online da Mercos. A funcionalidade “Ditar texto” requer permissão de microfone e funciona nos navegadores Chrome, Edge e Safari, mas não é suportada em Firefox e Opera."
    }
  }, {
    "@type": "Question",
    "name": "O recurso é integrado ao Mercos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Sim, tanto ao sistema de vendas quanto ao e-commerce B2B. A geração é automática dentro do sistema de vendas e, no e-commerce B2B, os pedidos viram carrinhos prontos para finalização pelos clientes, facilitando e agilizando toda a operação."
    }
  }]
};

var newFaqItems = faqJsonLd.mainEntity.map(function (item) {
  return {
    question: item.name,
    answer: _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        'p',
        null,
        item.acceptedAnswer.text
      )
    )
  };
});

var imageJsonLd = {
  "@context": "https://schema.org",
  "@type": "ImageObject",
  "contentUrl": "https://mercos.com/images/sistema-de-pedidos-com-ia.jpg",
  "url": "https://mercos.com/images/sistema-de-pedidos-com-ia.jpg",
  "name": "Sistema de pedidos com IA do Mercos",
  "description": "Captura de tela do WhatsApp para ser usada no recurso Pedidos com IA, mostrando que basta usar a conversa que chega pelo WhatsApp em diferentes formatos de mídia no sistema Mercos para criar um pedido no sistema com inteligência artificial. Ao lado é possível ver um exemplo de pedido com IA",
  "thumbnail": {
    "@type": "ImageObject",
    "contentUrl": "https://mercos.com/images/sistema-de-pedidos-com-ia.jpg"
  },
  "width": 530,
  "height": 600,
  "uploadDate": "2025-06-11",
  "license": "https://mercos.com/",
  "author": {
    "@type": "Organization",
    "name": "Mercos",
    "url": "https://www.mercos.com"
  },
  "copyrightHolder": {
    "@type": "Organization",
    "name": "Mercos"
  }
};

var videoJsonLd = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "name": "Sistema de pedidos com IA Mercos: solução para vendas ágeis e sem erros",
  "description": "Seu negócio precisa de mais agilidade e menos erros na gestão de pedidos? Conheça o Sistema de Pedidos com IA do Mercos, a solução definitiva para automatizar suas vendas e aumentar a eficiência da sua equipe! O Sistema de Pedidos com IA interpreta automaticamente mensagens de texto, fotos, áudios e arquivos enviados pelos seus clientes (via WhatsApp, e-mail, Telegram e outras plataformas!) e transforma tudo em pedidos ou orçamentos dentro do sistema Mercos. Com o Sistema de Pedidos com IA, você garante: Vendas rápidas: economize tempo na criação de pedidos e acelere o processo; Sem erros: reduza drasticamente os erros manuais com a interpretação inteligente da IA; Mais produtividade: libere sua equipe para focar em negociação e fechamento de vendas; Integração total: funciona perfeitamente com o sistema de vendas e e-commerce B2B do Mercos; Ideal para indústrias, distribuidoras e representantes, o Sistema de Pedidos com IA suporta diversos formatos de arquivo (PDF, imagens, áudios e mais, até 20MB) e é intuitivo. Você pode revisar e corrigir qualquer sugestão da IA antes de finalizar o pedido. Assista ao vídeo e veja na prática como a IA é a solução inteligente para ter vendas rápidas e Sem erros, otimizando sua gestão de pedidos e impulsionando seu negócio! Saiba mais sobre o Sistema de Pedidos com IA e experimente grátis: #SistemaDePedidosComIA #Mercos #AutomaçãoDeVendas #GestãoDePedidos #InteligênciaArtificial #EcommerceB2B #AutomaçãoComIA",
  "uploadDate": "2025-06-10T13:30:00-03:00",
  "thumbnailUrl": "https://i9.ytimg.com/vi_webp/HNs0zWQ8tX0/mqdefault.webp?v=6849a374&sqp=CLzupsIG&rs=AOn4CLC_PWWtUCuCgeCxpXuBJ49S9X0bpQ",
  "contentUrl": "https://youtu.be/HNs0zWQ8tX0",
  "embedUrl": "https://www.youtube.com/embed/HNs0zWQ8tX0",
  "publisher": {
    "@type": "Organization",
    "name": "Mercos"
  }
};

var SistemaDePedidosComIAComponent = function (_React$Component) {
  _inherits(SistemaDePedidosComIAComponent, _React$Component);

  function SistemaDePedidosComIAComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SistemaDePedidosComIAComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SistemaDePedidosComIAComponent.__proto__ || Object.getPrototypeOf(SistemaDePedidosComIAComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isSmall: false }, _this.handleResize = function (e) {
      return _this.setState({ isSmall: e.matches });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SistemaDePedidosComIAComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mq = window.matchMedia('(max-width: 900px)');
      this.handleResize(this.mq);
      this.mq.addEventListener('change', this.handleResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.mq) this.mq.removeEventListener('change', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var isSmall = this.state.isSmall;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_NewMenuv2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'sistema-de-pedidos-com-ia-page' },
          _react2.default.createElement(
            'section',
            { className: 'ia-hero container' },
            _react2.default.createElement(
              'div',
              { className: 'ia-hero-main-content' },
              _react2.default.createElement(
                'div',
                { className: 'ia-hero-title-container' },
                _react2.default.createElement(
                  'h1',
                  { className: 'ia-hero-title title' },
                  'Sistema de Pedidos com IA'
                ),
                _react2.default.createElement(_Picture2.default, { className: 'ia-hero-sparkle', alt: 'Sparkle', src: '/images/site/recursos/sparkle.svg' })
              ),
              _react2.default.createElement(
                'h2',
                { className: 'ia-hero-subtitle description' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Transforme mensagens do WhatsApp ou e-mails em pedidos em segundos'
                ),
                _react2.default.createElement('br', null),
                'Com o Sistema de Pedidos com IA, basta colar o texto do cliente, enviar um arquivo de foto, PDF, planilha ou \xE1udio e pronto: o pedido \xE9 gerado automaticamente'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'glow-wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'ia-hero-video' },
                _react2.default.createElement('iframe', {
                  width: '100%',
                  height: '100%',
                  src: 'https://www.youtube.com/embed/HNs0zWQ8tX0',
                  title: 'YouTube video player',
                  frameBorder: '0',
                  allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
                  allowFullScreen: true,
                  style: { borderRadius: '20px', position: 'absolute', top: 0, left: 0 }
                })
              )
            ),
            _react2.default.createElement(_HeroRatings2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'ia-hero-testimonial', id: 'ia-testimonial' },
              _react2.default.createElement(
                'p',
                { className: 'ia-testimonial-text' },
                '\u201CO sistema de ',
                _react2.default.createElement(
                  'b',
                  null,
                  'pedidos com IA da Mercos'
                ),
                ' tem nos ajudado muito aqui no escrit\xF3rio, especialmente na reta final do m\xEAs, quando v\xE1rios pedidos se acumulam. Com ele, \xE9 poss\xEDvel importar os pedidos com muito mais agilidade.\u201D'
              ),
              _react2.default.createElement(
                'div',
                { className: 'ia-testimonial-author' },
                _react2.default.createElement(_Picture2.default, { className: 'ia-author-avatar', alt: 'Joice Silva', src: '/images/site/depoimentos/joice-silva.png' }),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-author-details' },
                  _react2.default.createElement(
                    'span',
                    { className: 'ia-author-name' },
                    'Joice Silva',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'ia-author-title' },
                    'Gerente Comercial da empresa Musical Plus',
                    " "
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'ia-upload-section container' },
            _react2.default.createElement(
              'div',
              { className: 'ia-upload-content-wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'ia-upload-text-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'ia-upload-title-container' },
                  _react2.default.createElement(
                    'p',
                    { className: 'ia-upload-title' },
                    'Suba o arquivo',
                    _react2.default.createElement('br', null),
                    ' e deixe o resto',
                    _react2.default.createElement('br', null),
                    ' com a ',
                    _react2.default.createElement(
                      'span',
                      { className: 'ia-upload-title-highlight' },
                      'IA'
                    ),
                    _react2.default.createElement(_Picture2.default, { className: 'ia-upload-sparkle', alt: 'Sparkle', src: '/images/site/recursos/sparkling-green.png' })
                  )
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-upload-description' },
                  _react2.default.createElement(
                    'span',
                    { className: 'ia-upload-description-bold' },
                    'Chega de perder tempo lan\xE7ando pedidos manualmente!',
                    _react2.default.createElement('br', null),
                    ' ',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(_Picture2.default, { className: 'ia-upload-image mobile-only', alt: ' Imagem mostrando o Sistema de Pedidos com IA dentro do Mercos. \xC9 poss\xEDvel ver a tela de pedidos do sistema, com foco na inser\xE7\xE3o de documento em PDF, \xE1udio, v\xEDdeo, imagem ou planilha para a ferramenta ler o conte\xFAdo e o transformar em um pedido ap\xF3s clicar em "Encontrar Produtos".', src: '/images/site/recursos/pedidos-ia/adicionar-produtos-ia-mobile.png' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'ia-upload-description-regular' },
                    'Recebeu um pedido por WhatsApp ou e-mail e quer lan\xE7\xE1-lo no sistema Mercos de forma r\xE1pida e pr\xE1tica?',
                    _react2.default.createElement('br', null),
                    ' ',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'ia-upload-description-bold' },
                    'Em segundos'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'ia-upload-description-regular' },
                    ', o sistema de pedidos com IA interpreta as informa\xE7\xF5es e gera a lista de produtos para o pedido automaticamente para voc\xEA. Basta conferir e gerar o pedido!'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'ia-upload-image-content' },
                _react2.default.createElement(_Picture2.default, { className: 'ia-upload-image desktop-only', alt: ' Imagem mostrando o Sistema de Pedidos com IA dentro do Mercos. \xC9 poss\xEDvel ver a tela de pedidos do sistema, com foco na inser\xE7\xE3o de documento em PDF, \xE1udio, v\xEDdeo, imagem ou planilha para a ferramenta ler o conte\xFAdo e o transformar em um pedido ap\xF3s clicar em "Encontrar Produtos".', src: '/images/site/recursos/pedidos-ia/adicionar-produtos-ia.png' })
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'ia-file-types-section container' },
            _react2.default.createElement(
              'p',
              { className: 'ia-file-types-title' },
              'Cole textos, envie fotos, PDFs, \xE1udios ou planilhas'
            ),
            _react2.default.createElement(
              'div',
              { className: 'ia-file-type-cards-container' },
              _react2.default.createElement(
                'div',
                { className: 'ia-file-type-card' },
                _react2.default.createElement(_Picture2.default, { className: 'ia-file-type-icon', alt: 'Planilha Icon', src: '/images/site/recursos/icon-planilha.png' }),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-name' },
                  'Planilha'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-description' },
                  'Suba pedidos do Excel, .xlsx ou .csv'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'ia-file-type-card' },
                _react2.default.createElement(_Picture2.default, { className: 'ia-file-type-icon', alt: 'Audio Icon', src: '/images/site/recursos/icon-audio.png' }),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-name' },
                  '\xC1udio'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-description' },
                  'Envie arquivos',
                  _react2.default.createElement('br', null),
                  'ou dite o pedido'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'ia-file-type-card' },
                _react2.default.createElement(_Picture2.default, { className: 'ia-file-type-icon', alt: 'PDF Icon', src: '/images/site/recursos/icon-pdf.png' }),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-name' },
                  'PDF'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-description' },
                  'Salve e envie arquivos',
                  _react2.default.createElement('br', null),
                  'sem dificuldades'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'ia-file-type-card' },
                _react2.default.createElement(
                  'div',
                  { className: 'ia-file-type-icon-wrapper' },
                  _react2.default.createElement(_Picture2.default, { className: 'ia-file-type-icon image-icon', alt: 'Imagem Icon', src: '/images/site/recursos/icon-imagem.png' })
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-name' },
                  'Imagem'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-file-type-description' },
                  'Fotos viram pedidos',
                  _react2.default.createElement('br', null),
                  'rapidamente'
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'ia-reduce-errors-section container' },
            _react2.default.createElement(
              'div',
              { className: 'ia-reduce-errors-content-wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'ia-reduce-errors-image-content' },
                _react2.default.createElement(_Picture2.default, { className: 'ia-reduce-errors-image desktop-only', alt: 'Interface do sistema de pedidos com IA', src: '/images/sistema-de-pedidos-com-ia.jpg' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'ia-reduce-errors-text-content' },
                _react2.default.createElement(
                  'h3',
                  { className: 'ia-reduce-errors-title' },
                  'Reduza erros com o sistema de pedidos com IA'
                ),
                _react2.default.createElement(_Picture2.default, { className: 'ia-reduce-errors-image mobile-only', alt: 'Interface do sistema de pedidos com IA', src: '/images/site/recursos/pedidos-ia/reduza-erros-mobile.png' }),
                _react2.default.createElement(
                  'p',
                  { className: 'ia-reduce-errors-description' },
                  'A IA interpreta os pedidos automaticamente e ainda permite revis\xE3o antes de finalizar, o que evita falhas humanas e pedidos errados. Voc\xEA reduz o tempo gasto com tarefas operacionais e ganha produtividade em vendas, atendimento e negocia\xE7\xE3o.'
                ),
                _react2.default.createElement('hr', { className: 'ia-reduce-errors-divider' }),
                _react2.default.createElement(
                  'ul',
                  { className: 'ia-features-list' },
                  _react2.default.createElement(
                    'li',
                    { className: 'ia-feature-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'ia-feature-icon' },
                      _react2.default.createElement(_Picture2.default, { alt: 'Checkmark', src: '/images/site/recursos/checkmark.svg' })
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'ia-feature-text' },
                      'Recurso dispon\xEDvel para todos os planos e de forma ilimitada nos planos Ouro e Corporativo'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    { className: 'ia-feature-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'ia-feature-icon' },
                      _react2.default.createElement(_Picture2.default, { alt: 'Checkmark', src: '/images/site/recursos/checkmark.svg' })
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'ia-feature-text' },
                      'Use o bot\xE3o \u201CDitar texto\u201D para gravar um \xE1udio com os produtos que devem ser adicionados ao or\xE7amento'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    { className: 'ia-feature-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'ia-feature-icon' },
                      _react2.default.createElement(_Picture2.default, { alt: 'Checkmark', src: '/images/site/recursos/checkmark.svg' })
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'ia-feature-text' },
                      'Integrado ao e-commerce B2B: seus pedidos viram um carrinho em segundos'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_TwoColumnAccordionWithImage2.default, {
            isAIPage: true,
            mainTitleRegular: 'Eliminamos a digita\xE7\xE3o manual ',
            mainTitleBold: 'para voc\xEA focar no que realmente importa: vender',
            titleGraphicSrc: '/images/site/recursos/underline.png',
            titleGraphicAlt: 'Elemento gr\xE1fico decorativo',
            features: [{
              id: 'menos-erros',
              iconSrc: '/images/site/recursos/clipboard-check.svg',
              iconAlt: 'Ícone menos erros',
              title: 'Menos erros nos pedidos',
              description: 'O sistema de pedidos com IA interpreta o pedido automaticamente, você revisa os produtos, finaliza a venda e pode focar em visitas e reuniões mais qualificadas, novos clientes, resultados e métricas comerciais.',
              arrowSrc: '/images/site/recursos/arrow-down.svg',
              arrowAlt: 'Expandir/recolher',
              imageSrc: '/images/site/recursos/menos-erros.jpg',
              imageAlt: 'Visualização de menos erros com IA'
            }, {
              id: 'flexibilidade',
              iconSrc: '/images/site/recursos/process.svg',
              iconAlt: 'Ícone flexibilidade',
              title: 'Flexibilidade para vários formatos',
              description: 'O recurso Pedidos com IA aceita textos, fotos, áudios, PDFs e planilhas — assim, você pode enviar pedidos do jeito que for mais fácil, sem precisar reformatar nada.',
              arrowSrc: '/images/site/recursos/arrow-down.svg',
              arrowAlt: 'Expandir/recolher',
              imageSrc: '/images/site/recursos/flexibilidade.png',
              imageAlt: 'Diversos formatos suportados pela IA'
            }, {
              id: 'facilidade-equipes',
              iconSrc: '/images/site/recursos/people-plus.svg',
              iconAlt: 'Ícone facilidade para equipes',
              title: 'Facilidade para equipes externas e internas',
              description: 'Com a IA vendedores externos e televendas criam pedidos rapidamente pelo computador, ditando a conversa ou enviando arquivos. Isso aumenta a produtividade e o alcance da equipe.',
              arrowSrc: '/images/site/recursos/arrow-down.svg',
              arrowAlt: 'Expandir/recolher',
              imageSrc: '/images/site/recursos/facilidade.png',
              imageAlt: 'Equipes utilizando IA para pedidos'
            }],
            mainImageSrc: '/images/site/recursos/menos-erros.jpg',
            mainImageAlt: 'Persona focada em vender'
          }),
          _react2.default.createElement(
            'section',
            { className: 'ia-testimonial-section container' },
            _react2.default.createElement(_TestimonialVideoCards2.default, { isAI: true, isAIPage: true,
              title: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'Confira a opini\xE3o de quem j\xE1 usa'
                ),
                ' o sistema de pedidos com IA na Mercos'
              )
            })
          ),
          _react2.default.createElement(_TrustedByCompanies2.default, { isAIPage: true }),
          _react2.default.createElement(
            'section',
            { className: 'cta-test-section container' },
            _react2.default.createElement(_PromoBannerCTA2.default, {
              isAIPage: true,
              headline: _react2.default.createElement(
                _react.Fragment,
                null,
                'Teste o Mercos e conhe\xE7a o ',
                _react2.default.createElement('br', null),
                'sistema de pedidos com IA'
              )
            })
          ),
          _react2.default.createElement(
            'section',
            { className: 'faq-section container' },
            _react2.default.createElement(_GenericFAQ2.default, {
              isAIPage: true,
              title: _react2.default.createElement(
                _react.Fragment,
                null,
                'Perguntas frequentes sobre o sistema de pedidos com IA'
              ),
              defaultOpenIndex: 0,
              faqItems: newFaqItems
            })
          )
        ),
        _react2.default.createElement(_NewFooterV2.default, null)
      );
    }
  }]);

  return SistemaDePedidosComIAComponent;
}(_react2.default.Component);

exports.default = (0, _reactStatic.withRouteData)(function (_ref2) {
  var headData = _ref2.headData;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement(
        'title',
        null,
        headData && headData.pageTitle ? headData.pageTitle : 'Sistema de Pedidos com IA - Mercos'
      ),
      _react2.default.createElement('meta', { name: 'description', content: headData && headData.pageDescription ? headData.pageDescription : "Transforme mensagens do WhatsApp ou e-mails em pedidos em segundos com o Sistema de Pedidos com IA da Mercos." }),
      headData && headData.ogUrl && _react2.default.createElement('link', { rel: 'canonical', href: headData.ogUrl }),
      headData && headData.pageTitle && _react2.default.createElement('meta', { property: 'og:title', content: headData.pageTitle }),
      headData && headData.pageTitle && _react2.default.createElement('meta', { name: 'twitter:title', content: headData.pageTitle }),
      headData && headData.pageDescription && _react2.default.createElement('meta', { property: 'og:description', content: headData.pageDescription }),
      headData && headData.pageDescription && _react2.default.createElement('meta', { name: 'twitter:description', content: headData.pageDescription }),
      headData && headData.ogImage && _react2.default.createElement('meta', { property: 'og:image', content: headData.ogImage }),
      headData && headData.ogImage && _react2.default.createElement('meta', { name: 'twitter:image', content: headData.ogImage }),
      headData && headData.ogUrl && _react2.default.createElement('meta', { property: 'og:url', content: headData.ogUrl }),
      _react2.default.createElement(
        'script',
        { type: 'application/ld+json' },
        JSON.stringify(faqJsonLd)
      ),
      _react2.default.createElement(
        'script',
        { type: 'application/ld+json' },
        JSON.stringify(imageJsonLd)
      ),
      _react2.default.createElement(
        'script',
        { type: 'application/ld+json' },
        JSON.stringify(videoJsonLd)
      )
    ),
    _react2.default.createElement(SistemaDePedidosComIAComponent, null)
  );
});

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp,
        fetchPriority = _ref.fetchPriority,
        width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        loading = _ref.loading,
        onLoad = _ref.onLoad,
        srcSet = _ref.srcSet,
        sizes = _ref.sizes,
        decoding = _ref.decoding,
        imgProps = _objectWithoutProperties(_ref, ['src', 'webpSrc', 'mobileSrc', 'alt', 'className', 'desktop', 'mobile', 'noWebp', 'fetchPriority', 'width', 'height', 'style', 'loading', 'onLoad', 'srcSet', 'sizes', 'decoding']);

    // Detect external URLs - if src starts with http:// or https://, it's external
    var isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    var shouldSkipWebp = noWebp || isExternal;

    var extension = src.split('.').pop();
    var isSvg = extension.toLowerCase() === 'svg';
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';
    var loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    var commonImgProps = _extends({
        className: className + ' ' + desktopClass + ' ' + mobileClass,
        src: '' + src,
        alt: '' + alt,
        loading: loadingValue,
        width: width,
        height: height,
        style: style,
        onLoad: onLoad,
        srcSet: srcSet,
        sizes: sizes,
        decoding: decoding,
        fetchpriority: fetchPriority }, imgProps);

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return _react2.default.createElement('img', commonImgProps);
    }

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !shouldSkipWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !shouldSkipWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', commonImgProps)
    );
};

exports.default = Picture;

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	var gad_campaignid = _jsCookie2.default.get('madscampaignid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		params += gad_campaignid ? '&gad_campaignid=' + gad_campaignid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(538);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var telephoneMask = exports.telephoneMask = function telephoneMask(value) {
    var cleanTelephone = value ? value.replace(/\D/g, "") : '';
    var numberLength = cleanTelephone.length;

    if (numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
    } else if (numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
    }

    if (numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
    }

    if (numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0);
    }

    return cleanTelephone;
};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        inputPlaceholder = _ref.inputPlaceholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            placeholder: inputPlaceholder,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    inputPlaceholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(546);

var _Input2 = _interopRequireDefault(_Input);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

var _ModalTestimonials = __webpack_require__(552);

var _ModalTestimonials2 = _interopRequireDefault(_ModalTestimonials);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity', 'users'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoForm = function (_Component) {
    _inherits(DemoForm, _Component);

    function DemoForm(props) {
        _classCallCheck(this, DemoForm);

        var _this = _possibleConstructorReturn(this, (DemoForm.__proto__ || Object.getPrototypeOf(DemoForm)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var wrapper = document.activeElement.closest('.activity-wrapper');
            var button = wrapper.querySelector('.activity-dropdown-button');
            var dropdown = wrapper.querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopup = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoForm, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                typingTimeout: 0,
                partnerId: props.partnerId,
                rdWhatsappLauncherReady: false
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                value = value.trim();
                company = this.state.name + ' - ' + value;
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};
            var fieldsToValidate = FIELDS;

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            fieldsToValidate.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            if (!email) return false;
            var trimmedEmail = email.trim();
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(trimmedEmail.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'forca_de_vendas'
                };

                data['cf_numero_de_vendedores'] = this.state.users;

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/';
                if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo';else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
            if (this.props.replaceTrialWithWhatsapp) {
                this.watchRDWhatsappLauncher();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopRDWhatsappPoll();
            if (this.rdWhatsappFallbackTimer) {
                clearTimeout(this.rdWhatsappFallbackTimer);
            }
        }
    }, {
        key: 'isRDWhatsappLauncherReady',
        value: function isRDWhatsappLauncherReady() {
            if (typeof document === 'undefined') return false;
            return Boolean(document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button'));
        }
    }, {
        key: 'stopRDWhatsappPoll',
        value: function stopRDWhatsappPoll() {
            if (this.rdWhatsappPollTimer) {
                clearInterval(this.rdWhatsappPollTimer);
                this.rdWhatsappPollTimer = null;
            }
        }
    }, {
        key: 'watchRDWhatsappLauncher',
        value: function watchRDWhatsappLauncher() {
            var _this4 = this;

            if (this.isRDWhatsappLauncherReady()) {
                this.setState({ rdWhatsappLauncherReady: true });
                return;
            }

            if (typeof document === 'undefined') return;

            this.rdWhatsappPollTimer = setInterval(function () {
                if (!_this4.isRDWhatsappLauncherReady()) return;
                _this4.setState({ rdWhatsappLauncherReady: true });
                _this4.stopRDWhatsappPoll();
            }, 300);

            this.rdWhatsappFallbackTimer = setTimeout(function () {
                _this4.stopRDWhatsappPoll();
            }, 7000);
        }
    }, {
        key: 'openRDWhatsappLauncher',
        value: function openRDWhatsappLauncher(e) {
            e.preventDefault();

            if (typeof window !== 'undefined' && typeof window.__mercosOpenRDWhatsappLauncher === 'function') {
                if (window.__mercosOpenRDWhatsappLauncher()) return;
            }

            var launcher = typeof document !== 'undefined' ? document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button') : null;

            if (launcher) {
                launcher.click();
                return;
            }

            (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            if (this.props.minimalStyle) {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal modal-context' },
                        this.getInlineForm()
                    )
                );
            } else if (this.props.modalSmall) {
                return this.getDemoModalSmall();
            } else {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: 'site-simple-modal-testimonials' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header-logo' },
                        _react2.default.createElement('div', { className: 'logo-mercos-new-home' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            'Solicite uma demonstra\xE7\xE3o'
                        ),
                        this.getForm()
                    ),
                    _react2.default.createElement(_ModalTestimonials2.default, null)
                );
            }
        }
    }, {
        key: 'getDemoModalSmall',
        value: function getDemoModalSmall() {
            var _this6 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this6.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        this.getFormFloatingLabel()
                    )
                )
            );
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, '') : '';
            var numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this7 = this;

            return _react2.default.createElement(
                'form',
                { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                        return _this7.submitForm(e);
                    } },
                _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    'Nome'
                ),
                _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.nameError, autoFocus: true }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    'E-mail'
                ),
                _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.emailError }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'telephone' },
                    'Telefone'
                ),
                _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.telephoneError, maxLength: '15' }),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 a atividade da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.industria);
                            } },
                        'Ind\xFAstria'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                            } },
                        'Distribui\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.rep);
                            } },
                        'Representante comercial'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.outra);
                            } },
                        'Outra'
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.um);
                            } },
                        '1'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinco);
                            } },
                        '2-5'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.vinte);
                            } },
                        '6-20'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquenta);
                            } },
                        '21-50'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquentaum);
                            } },
                        '51 ou mais'
                    ),
                    this.state.usersError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-demo-modal' },
                    _react2.default.createElement(
                        _Button2.default,
                        { type: 'submit', radius: this.props.contaAzul ? 'all-rounded' : 'half-rounded', className: this.props.contaAzul && 'conta-azul' },
                        this.props.children || 'SOLICITAR'
                    )
                )
            );
        }
    }, {
        key: 'getFormFloatingLabel',
        value: function getFormFloatingLabel() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form new-form-floating-inputs' },
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-title' },
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-subtitle' },
                        'Um de nossos consultores entrar\xE1 em contato.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this8.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'wrapper-input-vendedores' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'label' },
                                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'group-buttons' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.um);
                                            } },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinco);
                                            } },
                                        '2-5'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.vinte);
                                            } },
                                        '6-20'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquenta);
                                            } },
                                        '21-50'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquentaum);
                                            } },
                                        '51 ou mais'
                                    ),
                                    this.state.usersError ? _react2.default.createElement(
                                        'div',
                                        { style: { color: 'red' } },
                                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                    ) : null
                                )
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewForm',
        value: function getNewForm() {
            var _this9 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this9.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getInlineForm',
        value: function getInlineForm() {
            var _this10 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this10.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.emailError, placeholder: this.props.formHeroStyle ? 'E-mail profissional' : 'Seu e-mail', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText || 'solicitar demonstração'
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        !this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'inline-trial-link modal-hide' },
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    },
                                    title: 'Fa\xE7a um teste gr\xE1tis'
                                },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'ou-text' },
                                    'ou'
                                ),
                                ' fa\xE7a um teste gr\xE1tis \u203A'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'inline-trial-info' },
                                'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'explore todos os recursos ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'n\xE3o precisa de cart\xE3o de cr\xE9dito ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this11 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: this.props.buttonShadow ? 'btn-white-shadow btn-modal ' : 'new-button button-secondary btn-modal ' + (this.props.darkBg ? 'button-secondary' : 'button-secondary-black') + ' button-cta',
                    onClick: function onClick(e) {
                        return _this11.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this12 = this;

            return _react2.default.createElement(
                'div',
                { className: 'or-demo-wrapper' },
                this.props.showOr && _react2.default.createElement(
                    'span',
                    { style: { textDecoration: 'none' } },
                    ' ou '
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: '.',
                        className: 'button-txt btn-modal ' + (this.props.darkBg ? 'button-txt-white' : ''),
                        onClick: function onClick(e) {
                            return _this12.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração ›'
                )
            );
        }
    }, {
        key: 'getTrialButton',
        value: function getTrialButton() {
            return _react2.default.createElement(
                'button',
                {
                    className: this.props.buttonShadow ? 'btn-green-shadow btn-trial' : 'new-button button-primary btn-trial button-cta button-trial ' + (this.props.darkBg ? 'dark-bg' : ''),
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    href: '#',
                    title: 'Cadastre-se no Mercos!'
                },
                this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this13 = this;

            if (this.props.minimalStyle) {
                var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
                var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

                return _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo mobile-only' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick(e) {
                                return _this13.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'peça uma demonstração'
                    ),
                    !this.props.hideTrialButton && _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick() {
                                return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                            },
                            href: '#',
                            title: 'Cadastre-se no Mercos!'
                        },
                        this.props.trialAndDemo || 'Faça um teste grátis'
                    ),
                    this.props.invertButtons && _react2.default.createElement(
                        'p',
                        { className: 'trial-info-text' },
                        'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                    )
                );
            }

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo ' + (this.props.reverseButtons ? 'reverse-buttons' : '') },
                    !this.props.hideTrialButton && this.getTrialButton(),
                    this.props.modalLink ? this.getModalLink() : this.getModalButton()
                ),
                this.props.ctaText ? this.getCTA() : ''
            );
        }
    }, {
        key: 'getNewFormButtons',
        value: function getNewFormButtons() {
            var _this14 = this;

            var _props = this.props,
                buttonVariant = _props.buttonVariant,
                textAlign = _props.textAlign,
                ctaButtonText = _props.ctaButtonText,
                demoButtonText = _props.demoButtonText,
                bottomText = _props.bottomText;


            var isWhiteVariant = buttonVariant === 'white' || buttonVariant === 'inverted-white';
            var isInverted = buttonVariant === 'inverted' || buttonVariant === 'inverted-white';

            // Determine outline color (white or green)
            var outlineClass = isWhiteVariant ? 'new-form-btn-bordered-white' : 'new-form-btn-bordered-green';

            // Default: Faça=solid, Peça=outline
            // Inverted: Peça=solid, Faça=outline
            var trialButtonClass = isInverted ? 'new-form-btn ' + outlineClass : 'new-form-btn new-form-btn-solid-green';
            var demoButtonClass = isInverted ? 'new-form-btn new-form-btn-solid-green' : 'new-form-btn ' + outlineClass;

            var trialButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass,
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    title: 'Cadastre-se no Mercos!'
                },
                ctaButtonText || 'Faça um teste grátis'
            );

            var whatsappButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass + ' new-form-whatsapp-btn',
                    onClick: function onClick(e) {
                        return _this14.openRDWhatsappLauncher(e);
                    },
                    title: 'Fale conosco no WhatsApp'
                },
                _react2.default.createElement(
                    'span',
                    { className: 'new-form-whatsapp-icon', 'aria-hidden': 'true' },
                    _react2.default.createElement(_Picture2.default, { src: '/images/site/whatsapp.png', alt: '' })
                ),
                this.props.whatsappButtonText || 'Fale conosco no WhatsApp'
            );

            var demoButton = _react2.default.createElement(
                'button',
                {
                    className: demoButtonClass,
                    onClick: function onClick(e) {
                        return _this14.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                demoButtonText || 'Peça uma demonstração'
            );

            var primaryButton = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? whatsappButton : trialButton;
            var currentBottomText = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? this.props.whatsappBottomText : bottomText;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-buttons-wrapper text-align-' + textAlign },
                    _react2.default.createElement(
                        'div',
                        { className: 'new-form-buttons-container' },
                        isInverted ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            demoButton,
                            primaryButton
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            primaryButton,
                            demoButton
                        )
                    ),
                    currentBottomText && _react2.default.createElement(
                        'p',
                        { className: 'new-form-bottom-text' },
                        currentBottomText.includes('|') ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'desktop-text' },
                                currentBottomText
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'mobile-text' },
                                currentBottomText.split('|').map(function (part, index) {
                                    return _react2.default.createElement(
                                        _react.Fragment,
                                        { key: index },
                                        part.trim(),
                                        index < currentBottomText.split('|').length - 1 && _react2.default.createElement('br', null)
                                    );
                                })
                            )
                        ) : currentBottomText
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this15 = this;

            // Only show buttons WITH form when minimalStyle + showForm + modalButtonText (final CTA case)
            // Otherwise follow normal logic (buttons only when !showForm)
            var shouldShowButtons = this.props.minimalStyle && this.props.showForm && this.props.modalButtonText ? true : !this.props.showForm;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper ' + (this.props.inline || this.props.minimalStyle ? 'new-form-wrapper-b2b' : '') + ' ' + (this.props.ctaText ? 'same-width-buttons' : '') + ' ' + (this.props.darkBg ? 'dark-bg' : '') + ' ' + (this.props.fixedBottomBar ? 'demo-fixed-bottom' : '') + ' ' + (this.props.inlineBtns ? 'inline' : '') + ' ' + (this.props.newForm ? 'new-form-variant' : '') + ' ' + (this.props.buttonVariant === 'white' || this.props.buttonVariant === 'inverted-white' ? 'variant-white' : '') + ' ' + (this.props.className ? this.props.className : '') },
                    shouldShowButtons && this.props.newForm ? this.getNewFormButtons() : shouldShowButtons && this.props.trialButtonOnly ? _react2.default.createElement(
                        'button',
                        {
                            className: 'btn-green-shadow btn-modal',
                            onClick: function onClick(e) {
                                return _this15.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'quero contratar'
                    ) : shouldShowButtons ? this.getTrialAndDemo() : null,
                    this.props.showForm ? _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.props.inline || this.props.minimalStyle ? this.getInlineForm() : this.getForm()
                    ) : '',
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoForm;
}(_react.Component);

DemoForm.propTypes = {
    b2b: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    contaAzul: _propTypes2.default.bool,
    partnerId: _propTypes2.default.string,
    modalSmall: _propTypes2.default.bool,
    trialButtonOnly: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    newForm: _propTypes2.default.bool,
    buttonVariant: _propTypes2.default.oneOf(['default', 'inverted', 'white', 'inverted-white']),
    textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
    ctaButtonText: _propTypes2.default.string,
    demoButtonText: _propTypes2.default.string,
    bottomText: _propTypes2.default.string,
    minimalStyle: _propTypes2.default.bool,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    hideTitle: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool,
    replaceTrialWithWhatsapp: _propTypes2.default.bool,
    whatsappButtonText: _propTypes2.default.string,
    whatsappBottomText: _propTypes2.default.string
};
DemoForm.defaultProps = {
    b2b: false,
    contaAzul: false,
    trialButtonOnly: false,
    inline: false,
    newForm: true,
    buttonVariant: 'default',
    textAlign: 'center',
    ctaButtonText: 'Faça um teste grátis',
    demoButtonText: 'Peça uma demonstração',
    bottomText: 'Teste grátis por 7 dias | Sem cobrança automática',
    minimalStyle: false,
    showTrialLink: false,
    invertButtons: false,
    hideTitle: false,
    formHeroStyle: false,
    replaceTrialWithWhatsapp: false,
    whatsappButtonText: 'Fale conosco no WhatsApp',
    whatsappBottomText: ''
};
exports.default = DemoForm;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(545);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var accessLinks = [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }];

    var footerRows = [[{
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/' }, { name: 'CRM', url: '/crm-de-vendas' }, { name: 'Mercos Pay', url: '/mercos-pay' }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Recursos',
        links: [{ name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' }, { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' }, { name: 'Mercos IA', url: '/recursos/mercos-ia/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/', external: true }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true }, { name: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                'E-commerce B2B: O',
                _react2.default.createElement('br', null),
                'que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true }, { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true }, {
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }], [{
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Planos e preços',
        links: [{ name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' }, { name: 'Representantes', url: '/planos-e-precos/representantes/' }]
    }, {
        title: 'Institucional',
        links: [{ name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Integrações',
        links: [{ name: 'ERPs integrados', url: '/integracao-erp/' }, { name: 'Seja Parceiro', url: '/parceiros' }, { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }]
    }, {
        title: 'Baixe o aplicativo',
        content: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'app-buttons' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'app-downloads' },
                _react2.default.createElement(
                    'strong',
                    null,
                    '+100 mil'
                ),
                ' downloads'
            )
        )
    }]];

    var renderLink = function renderLink(link) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer-link';

        if (link.custom) return link.content;
        var target = link.target || (link.external ? '_blank' : null);

        return _react2.default.createElement(
            'a',
            {
                className: className,
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name,
            link.external && _react2.default.createElement(
                'span',
                { className: 'material-icons site-footer__external-icon', 'aria-hidden': 'true' },
                'north_east'
            )
        );
    };

    var socialLinks = [{ name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer site-footer', 'aria-label': 'Rodap\xE9' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content site-footer__inner' },
            _react2.default.createElement(
                'div',
                { className: 'site-footer__access' },
                _react2.default.createElement(
                    'p',
                    { className: 'site-footer__access-txt' },
                    'J\xE1 \xE9 cliente ou quer come\xE7ar?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-footer__access-actions' },
                    accessLinks.map(function (link, index) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: link.url },
                            renderLink(link, 'site-footer__access-btn site-footer__access-btn--' + (index === 0 ? 'login' : 'signup'))
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'nav',
                { className: 'footer-main site-footer__nav', 'aria-label': 'Links do rodap\xE9' },
                footerRows.map(function (row, rowIndex) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'site-footer__nav-row', key: rowIndex },
                        row.map(function (section) {
                            return _react2.default.createElement(
                                'section',
                                { className: 'footer-section site-footer__section', key: section.title },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'section-title site-footer__col-title' },
                                    section.title
                                ),
                                section.content || _react2.default.createElement(
                                    'div',
                                    { className: 'section-links site-footer__links' },
                                    section.links.map(function (link, linkIndex) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'link-item', key: link.url || linkIndex },
                                            renderLink(link, 'footer-link site-footer__link')
                                        );
                                    })
                                )
                            );
                        })
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer-bottom site-footer__bar' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container site-footer__bar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo-container' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'mercos-logo site-footer__bar-logo-link' },
                        _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'company-info site-footer__legal' },
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA9 ',
                        new Date().getFullYear(),
                        ' Simplest Software Ltda. Todos os direitos reservados.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        'CNPJ: 12.496.510/0001-80 \xB7 Av. Rolf Wiest, 277 (4\xBA andar) \xB7 Bom Retiro \u2014 Joinville/SC \xB7 CEP: 89223-005'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'social-links site-footer__social' },
                    socialLinks.map(function (social) {
                        return _react2.default.createElement(
                            'a',
                            {
                                key: social.name,
                                href: social.url,
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                className: 'social-link site-footer__social-link',
                                'aria-label': social.name
                            },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: social.icon, alt: 'Mercos no ' + social.name })
                        );
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'feito-com-amor site-footer__made' },
                        'Feito com \uD83D\uDC9C'
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

__webpack_require__(548);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _siteNavData = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderItemTitle = function renderItemTitle(title) {
  if (typeof title === 'string') {
    return _react2.default.createElement(
      'h4',
      null,
      title
    );
  }
  return _react2.default.createElement(
    'h4',
    null,
    title
  );
};

var SiteNav = function SiteNav(_ref) {
  var _ref$hideOnScroll = _ref.hideOnScroll,
      hideOnScroll = _ref$hideOnScroll === undefined ? false : _ref$hideOnScroll,
      _ref$menuVisible = _ref.menuVisible,
      menuVisible = _ref$menuVisible === undefined ? true : _ref$menuVisible,
      _ref$pixelsToShowMenu = _ref.pixelsToShowMenuWhite,
      pixelsToShowMenuWhite = _ref$pixelsToShowMenu === undefined ? 50 : _ref$pixelsToShowMenu,
      _ref$transparentOnTop = _ref.transparentOnTop,
      transparentOnTop = _ref$transparentOnTop === undefined ? false : _ref$transparentOnTop,
      _ref$whiteBackground = _ref.whiteBackground,
      whiteBackground = _ref$whiteBackground === undefined ? false : _ref$whiteBackground,
      _ref$promoBarHeight = _ref.promoBarHeight,
      promoBarHeight = _ref$promoBarHeight === undefined ? 0 : _ref$promoBarHeight,
      _ref$loginOnly = _ref.loginOnly,
      loginOnly = _ref$loginOnly === undefined ? false : _ref$loginOnly,
      _ref$logoOnly = _ref.logoOnly,
      logoOnly = _ref$logoOnly === undefined ? false : _ref$logoOnly;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isAtTop = _useState4[0],
      setIsAtTop = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileMenuOpen = _useState6[0],
      setMobileMenuOpen = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileOpenSections = _useState8[0],
      setMobileOpenSections = _useState8[1];

  var closeTimerRef = (0, _react.useRef)(null);
  var dropdownRefs = (0, _react.useRef)([]);

  var showTransparentTop = transparentOnTop && isAtTop && !whiteBackground && !mobileMenuOpen;

  var closeMobileMenu = (0, _react.useCallback)(function () {
    setMobileMenuOpen(false);
    setMobileOpenSections({});
  }, []);

  var toggleMobileMenu = function toggleMobileMenu() {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      setMobileMenuOpen(true);
    }
  };

  var toggleMobileSection = function toggleMobileSection(index) {
    setMobileOpenSections(function (prev) {
      return _extends({}, prev, _defineProperty({}, index, !prev[index]));
    });
  };

  var closeAllDropdowns = function closeAllDropdowns() {
    return setActiveMenu(null);
  };

  var handleNavItemEnter = function handleNavItemEnter(index) {
    clearTimeout(closeTimerRef.current);
    setActiveMenu(index);

    var dd = dropdownRefs.current[index];
    if (!dd) return;

    dd.style.left = '';
    dd.style.right = '';

    requestAnimationFrame(function () {
      var rect = dd.getBoundingClientRect();
      var vw = window.innerWidth;
      if (rect.right > vw - 8) {
        var overflow = rect.right - (vw - 8);
        var currentLeft = parseFloat(window.getComputedStyle(dd).left) || 0;
        if (dd.style.right === '') {
          dd.style.left = currentLeft - overflow + 'px';
        }
      }
      if (rect.left < 8) {
        dd.style.left = '0px';
      }
    });
  };

  var handleNavItemLeave = function handleNavItemLeave(index) {
    closeTimerRef.current = setTimeout(function () {
      setActiveMenu(function (current) {
        return current === index ? null : current;
      });
    }, 100);
  };

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsAtTop(scrollTop <= pixelsToShowMenuWhite);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pixelsToShowMenuWhite]);

  (0, _react.useEffect)(function () {
    document.body.classList.toggle('mobile-menu-is-open', mobileMenuOpen);
    if (!mobileMenuOpen) {
      return undefined;
    }

    var onKeyDown = function onKeyDown(event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.body.classList.remove('mobile-menu-is-open');
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen, closeMobileMenu]);

  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(event) {
      if (!event.target.closest('.site-nav__item')) {
        closeAllDropdowns();
      }
    };

    var onEscape = function onEscape(event) {
      if (event.key === 'Escape') {
        closeAllDropdowns();
      }
    };

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onEscape);

    return function () {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onEscape);
      clearTimeout(closeTimerRef.current);
    };
  }, []);

  var navClassName = ['site-nav', hideOnScroll ? 'hide-on-scroll' : '', hideOnScroll && !menuVisible ? 'menu-hidden' : 'menu-visible', showTransparentTop ? 'at-top' : 'scrolled', promoBarHeight > 0 ? 'has-promo-bar' : '', mobileMenuOpen ? 'mobile-open' : '', logoOnly ? 'logo-only' : ''].filter(Boolean).join(' ');

  var menuItems = loginOnly ? [] : _siteNavData.siteNavData;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' })
    ),
    _react2.default.createElement(
      'header',
      { className: navClassName, id: 'siteHeader' },
      _react2.default.createElement(
        'a',
        { href: '/', className: 'site-nav__logo', 'aria-label': 'Mercos' },
        _react2.default.createElement(_Picture2.default, {
          src: '/images/site/logo-mercos-colored.svg',
          alt: 'Mercos',
          className: 'site-nav__logo-img'
        })
      ),
      !loginOnly && !logoOnly && _react2.default.createElement(
        'nav',
        { className: 'site-nav__desktop', 'aria-label': 'Navega\xE7\xE3o principal' },
        _react2.default.createElement(
          'ul',
          { className: 'site-nav__menu' },
          menuItems.map(function (menuItem, idx) {
            return _react2.default.createElement(
              'li',
              {
                key: menuItem.label,
                className: 'site-nav__item' + (activeMenu === idx ? ' open' : ''),
                onMouseEnter: function onMouseEnter() {
                  return handleNavItemEnter(idx);
                },
                onMouseLeave: function onMouseLeave() {
                  return handleNavItemLeave(idx);
                }
              },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'site-nav__trigger',
                  'aria-haspopup': 'true',
                  'aria-expanded': activeMenu === idx
                },
                menuItem.label
              ),
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    dropdownRefs.current[idx] = el;
                  },
                  className: 'site-nav__dropdown' + (menuItem.grid ? ' site-nav__dropdown--grid' : ''),
                  role: 'menu'
                },
                menuItem.items.map(function (item, subIdx) {
                  if (item.type === 'separator') {
                    return _react2.default.createElement(
                      'div',
                      { key: item.label + '-' + subIdx, className: 'site-nav__dd-label' },
                      item.label
                    );
                  }

                  return _react2.default.createElement(
                    'a',
                    {
                      key: item.link + '-' + subIdx,
                      href: item.link,
                      className: 'site-nav__dd-item',
                      role: 'menuitem',
                      target: item.target,
                      rel: item.target === '_blank' ? 'noopener noreferrer' : undefined
                    },
                    _react2.default.createElement(
                      'span',
                      { className: 'material-icons site-nav__dd-icon' },
                      item.icon
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'site-nav__dd-text' },
                      renderItemTitle(item.title),
                      item.description ? _react2.default.createElement(
                        'p',
                        null,
                        item.description
                      ) : null
                    )
                  );
                })
              )
            );
          })
        )
      ),
      !logoOnly && _react2.default.createElement(
        'div',
        { className: 'site-nav__actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__mobile-cta',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
          }
        },
        'comece gr\xE1tis'
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__hamburger' + (mobileMenuOpen ? ' active' : ''),
          id: 'headerHamburger',
          'aria-label': mobileMenuOpen ? 'Fechar menu' : 'Abrir menu',
          'aria-expanded': mobileMenuOpen,
          'aria-controls': 'mobileNav',
          onClick: toggleMobileMenu
        },
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null)
      )
    ),
    !logoOnly && _react2.default.createElement(
      'nav',
      {
        className: 'site-nav__mobile' + (mobileMenuOpen ? ' active' : ''),
        id: 'mobileNav',
        'aria-label': 'Menu mobile',
        'aria-hidden': !mobileMenuOpen
      },
      menuItems.map(function (menuItem, idx) {
        return _react2.default.createElement(
          'div',
          {
            key: menuItem.label,
            className: 'site-nav__mob-section' + (mobileOpenSections[idx] ? ' open' : '')
          },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'site-nav__mob-toggle',
              onClick: function onClick() {
                return toggleMobileSection(idx);
              }
            },
            menuItem.label,
            _react2.default.createElement(
              'span',
              { className: 'material-icons' },
              'expand_more'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'site-nav__mob-items' },
            _react2.default.createElement(
              'div',
              { className: 'site-nav__mob-items-inner' },
              menuItem.items.map(function (item, subIdx) {
                if (item.type === 'separator') {
                  return _react2.default.createElement(
                    'div',
                    { key: item.label + '-' + subIdx, className: 'site-nav__mob-label' },
                    item.label
                  );
                }

                return _react2.default.createElement(
                  'a',
                  {
                    key: item.link + '-' + subIdx,
                    href: item.link,
                    className: 'site-nav__mob-item',
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: closeMobileMenu
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'material-icons' },
                    item.icon
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    renderItemTitle(item.title),
                    item.description ? _react2.default.createElement(
                      'p',
                      null,
                      item.description
                    ) : null
                  )
                );
              })
            )
          )
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'site-nav__mob-actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      )
    )
  );
};

exports.default = SiteNav;

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteNavData = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteNavData = exports.siteNavData = [{
  label: 'Soluções',
  items: [{
    title: 'Força de vendas',
    description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
    icon: 'bar_chart',
    link: '/forca-vendas/'
  }, {
    title: 'E-commerce B2B',
    description: 'Venda 24h por dia com a loja online de empresas para empresas',
    icon: 'shopping_cart',
    link: '/e-commerce-b2b'
  }, {
    type: 'separator',
    label: 'Outras Soluções'
  }, {
    title: 'CRM',
    description: 'Cuide da prospecção ao pós-venda dos clientes em um só lugar',
    icon: 'filter_alt',
    link: '/crm-de-vendas'
  }, {
    title: 'Mercos Pay',
    description: 'Receba pagamentos por pix, boleto e cartões de crédito',
    icon: 'credit_card',
    link: '/mercos-pay'
  }, {
    title: 'Videochamada',
    description: 'Venda por vídeo com experiência de visita presencial',
    icon: 'videocam',
    link: '/videochamada'
  }]
}, {
  label: 'Segmentos',
  items: [{
    title: 'Indústrias',
    description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
    icon: 'factory',
    link: '/sistema-para-industria/'
  }, {
    title: 'Distribuidoras',
    description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
    icon: 'home_work',
    link: '/sistema-distribuidora/'
  }, {
    title: 'Representantes',
    description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
    icon: 'work',
    link: '/sistema-representante/'
  }]
}, {
  label: 'Planos e preços',
  items: [{
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Ind\xFAstrias e distribuidoras'
      )
    ),
    description: '',
    icon: 'factory',
    link: '/planos-e-precos/industrias-e-distribuidoras/'
  }, {
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Representantes'
      )
    ),
    description: '',
    icon: 'work',
    link: '/planos-e-precos/representantes/'
  }]
}, {
  label: 'Integrações',
  items: [{
    title: 'ERPs integrados',
    description: '+250 ERPs parceiros integrados ao Força de vendas e E-commerce B2B',
    icon: 'device_hub',
    link: '/integracao-erp'
  }, {
    title: 'Seja Parceiro',
    description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
    icon: 'people',
    link: '/parceiros'
  }]
}, {
  label: 'Recursos',
  grid: true,
  items: [{
    title: 'Aplicativo de vendas',
    description: 'Emita pedidos até sem internet e agilize a rotina do seu time comercial.',
    icon: 'smartphone',
    link: '/recursos/aplicativo-vendas-externas/'
  }, {
    title: 'Mercos IA',
    description: 'Inteligência Artificial na palma da sua mão',
    icon: 'auto_awesome',
    link: '/recursos/mercos-ia/'
  }, {
    title: 'Indicadores de vendas',
    description: 'Visualize a performance do seu comercial em tempo real e tome decisões mais rápidas.',
    icon: 'show_chart',
    link: '/recursos/indicadores-performance/'
  }, {
    title: 'Materiais ricos',
    description: 'Ebooks e guias para turbinar sua estratégia de vendas B2B.',
    icon: 'menu_book',
    link: '/materiais/'
  }, {
    title: 'Políticas comerciais',
    description: 'Aplique regras de preço, desconto e acréscimo sem erro – tudo de forma automática.',
    icon: 'flag',
    link: '/recursos/politica-comercial-vendas/'
  }, {
    title: 'Cases',
    description: 'Veja cases de sucesso e inspire melhores resultados para sua empresa.',
    icon: 'rocket_launch',
    link: 'https://mercos.com/cases/'
  }]
}];

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TESTIMONIALS = [{
    testimonial: "“Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades”",
    author: "Alexandre Santos",
    company: "Delícia Lanches"
}, {
    testimonial: "“Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.”",
    author: "Rafael A. Krause",
    company: "Grupo Herbia"
}, {
    testimonial: "“Meu Foco é ajudar clientes a fazer negócios, para isso uso tanto o presencial quanto a tecnologia como aliados”",
    author: "Felipe Rodrigues",
    company: "IF Consultoria e Representação"
}, {
    testimonial: "“Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.”",
    author: "Afonso Tonelli",
    company: "Musical Plus Representações"
}];
var TESTIMONIALS2 = [{
    testimonial: "“Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.”",
    author: "Gustavo Ribeiro",
    company: "Impacttus Cosméticos"
}, {
    testimonial: "“Passamos a prospectar e vender, além do presencial, 24 horas e 7 dias da semana para os clientes! Nosso intuito era vender além do território que atingíamos com as vendas externas. E foi isso que começamos a fazer, em pouquíssimo tempo!”",
    author: "Alan Alves",
    company: "Almmati"
}, {
    testimonial: "“Minha melhor experiência com a Mercos, é a facilidade que ele me dá na rua. A dinâmica que eu tenho e o volume de informações que eu consigo, isso me facilita muito!”",
    author: "Cristiano Oliveira",
    company: "Representante Comercial Harman"
}];

var ModalTestimonials = function (_Component) {
    _inherits(ModalTestimonials, _Component);

    function ModalTestimonials() {
        _classCallCheck(this, ModalTestimonials);

        return _possibleConstructorReturn(this, (ModalTestimonials.__proto__ || Object.getPrototypeOf(ModalTestimonials)).apply(this, arguments));
    }

    _createClass(ModalTestimonials, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col' },
                    TESTIMONIALS.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col testimonials-col2' },
                    TESTIMONIALS2.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                )
            );
        }
    }]);

    return ModalTestimonials;
}(_react.Component);

exports.default = ModalTestimonials;

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoFormB2B = function (_Component) {
    _inherits(DemoFormB2B, _Component);

    function DemoFormB2B(props) {
        _classCallCheck(this, DemoFormB2B);

        var _this = _possibleConstructorReturn(this, (DemoFormB2B.__proto__ || Object.getPrototypeOf(DemoFormB2B)).call(this, props));

        _this.handleActivityChange = function (activity) {
            _this.setState({ selectedActivity: activity });
        };

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopupB2B = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoFormB2B, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                partnerId: props.partnerId
            };
            var fields = props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = (0, _masks.telephoneMask)(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                company = this.state.name + ' - ' + value;
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(users) {
            this.setState({ 'users': users });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this2 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            var fields = this.props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                newState[campo + 'Error'] = !_this2.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this2.validateEmail(_this2.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this2.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'fale-consultor-b2b',
                    'cf_tipo_de_conversao': 'Solicitou demonstração E-commerce B2B',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'ecommerce_b2b'
                };

                if (this.props.showUsersField) {
                    data['cf_numero_de_vendedores'] = this.state.users;
                }

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-b2b/';
                if (this.state.activity === ACTIVITY.rep || this.state.activity === ACTIVITY.outra) {
                    redirectLink = 'https://materiais.mercos.com/tp-demo-b2b';
                } else if (this.props.euCommerce) {
                    redirectLink = 'https://mercos.com/tp/tp-parceria-mercos-eucommerce/';
                } else if (this.props.b2bPromo) {
                    redirectLink = 'https://materiais.mercos.com/tp-clientes-demo-b2b';
                }
                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this3 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this3.closeDemoModal();
                    }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    this.getForm()
                )
            );
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this4 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração',
                        ' ',
                        this.props.euCommerce ? this.props.euCommerce : '',
                        ' ',
                        this.props.b2bPromo ? this.props.b2bPromo : ''
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        this.props.formHeroStyle ? _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }) : _react2.default.createElement(_InputFloatingLabel2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        this.props.showUsersField && _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        (this.props.showForm || this.props.inline) && !this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-button-form' },
                    this.getModalButton(),
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'integra\xE7\xE3o com mais de 200 ERPs ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'venda 24h por dia, 7 dias por semana ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this5 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'button',
                    {
                        href: '.',
                        className: 'new-button  ' + (this.props.trialAndDemo ? 'button-secondary' : 'button-primary'),
                        onClick: function onClick(e) {
                            return _this5.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || this.props.children || 'peça uma demonstração'
                ),
                this.props.buttonOnly && _react2.default.createElement(
                    'p',
                    { className: 'button-only-trial-info' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this6 = this;

            return _react2.default.createElement(
                'a',
                {
                    href: '.',
                    className: 'button-txt ' + (this.props.darkBg ? 'button-txt-white' : ''),
                    onClick: function onClick(e) {
                        return _this6.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.modalButtonText || 'conheça o E-commerce B2B ›'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this7 = this;

            var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
            var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

            return _react2.default.createElement(
                'div',
                { className: 'wrapper-trial-and-demo mobile-only' },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick(e) {
                            return _this7.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração'
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick() {
                            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                        },
                        href: '#',
                        title: 'Cadastre-se no Mercos!'
                    },
                    this.props.trialAndDemo
                ),
                this.props.invertButtons && _react2.default.createElement(
                    'p',
                    { className: 'trial-info-text' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper new-form-wrapper-b2b' },
                    this.props.modaLink ? this.getModalLink() : this.props.trialAndDemo ? this.getTrialAndDemo() : this.props.buttonOnly ? this.getModalButton() : this.getCTA(),
                    this.props.showForm && _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.getForm()
                    ),
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoFormB2B;
}(_react.Component);

DemoFormB2B.propTypes = {
    b2b: _propTypes2.default.bool,
    contaAzul: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    radius: _propTypes2.default.string,
    partnerId: _propTypes2.default.string,
    buttonOnly: _propTypes2.default.bool,
    modalButtonText: _propTypes2.default.string,
    hideTitle: _propTypes2.default.bool,
    submitButtonText: _propTypes2.default.string,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    showUsersField: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool
};
DemoFormB2B.defaultProps = {
    b2b: false,
    contaAzul: false,
    radius: 'half-rounded',
    buttonOnly: false,
    hideTitle: false,
    submitButtonText: 'Solicitar demonstração',
    showTrialLink: false,
    invertButtons: false,
    showUsersField: true,
    formHeroStyle: false
};
exports.default = DemoFormB2B;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Constants for Mercos site numbers
// Centralized place to manage all the client numbers and revenue figures

var SITE_CONSTANTS = exports.SITE_CONSTANTS = {
  // Client numbers (updated to 9 mil)
  CLIENTS_COUNT: '9 mil',
  CLIENTS_COUNT_WITH_PLUS: '+9 mil',
  CLIENTS_COUNT_DETAILED: '9.000',
  CLIENTS_COUNT_WITH_COMMA: '9 mil',

  // Revenue (updated to 100 bi)
  ANNUAL_REVENUE: 'R$ 100 BI',
  ANNUAL_REVENUE_LOWERCASE: 'R$ 100 bi',

  // App ratings
  GOOGLE_PLAY_RATING: '4,9',
  GOOGLE_PLAY_REVIEWS: '7 mil avaliações',
  APP_STORE_RATING: '4,8',
  APP_STORE_REVIEWS: '2,8 mil avaliações',
  GOOGLE_BUSINESS_RATING: '4,6',
  GOOGLE_BUSINESS_REVIEWS: '701 avaliações',

  // Other numbers that might be used
  USERS_COUNT: '+52 mil',
  USERS_COUNT_DETAILED: '56.000',
  ERPS_INTEGRATED: '+250',
  ANNUAL_ORDERS: '+ 14 MI'

  // Helper functions to get formatted numbers
};var getClientsCount = exports.getClientsCount = function getClientsCount() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

  switch (format) {
    case 'plus':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS;
    case 'detailed':
      return SITE_CONSTANTS.CLIENTS_COUNT_DETAILED;
    case 'comma':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA;
    default:
      return SITE_CONSTANTS.CLIENTS_COUNT;
  }
};

var getRevenue = exports.getRevenue = function getRevenue() {
  var lowercase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return lowercase ? SITE_CONSTANTS.ANNUAL_REVENUE_LOWERCASE : SITE_CONSTANTS.ANNUAL_REVENUE;
};

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyYouTube = function LazyYouTube(_ref) {
    var videoId = _ref.videoId,
        coverImage = _ref.coverImage,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 300 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 550 : _ref$height,
        _ref$playerParams = _ref.playerParams,
        playerParams = _ref$playerParams === undefined ? '' : _ref$playerParams,
        _ref$useNoCookie = _ref.useNoCookie,
        useNoCookie = _ref$useNoCookie === undefined ? false : _ref$useNoCookie;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isLoaded = _useState2[0],
        setIsLoaded = _useState2[1];

    var embedBaseUrl = useNoCookie ? 'https://www.youtube.com/embed/' : 'https://www.youtube.com/embed/';
    var embedParams = ['autoplay=1', playerParams].filter(Boolean).join('&');

    var handleClick = function handleClick() {
        setIsLoaded(true);
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: 'video_play',
                videoId: videoId,
                videoTitle: title || 'YouTube video player',
                videoUrl: '' + embedBaseUrl + videoId
            });
        }
    };

    if (isLoaded) {
        return _react2.default.createElement(
            'div',
            { className: 'lazy-youtube-frame', style: { aspectRatio: width + ' / ' + height } },
            _react2.default.createElement('iframe', {
                className: 'lazy-youtube-embed',
                width: width,
                height: height,
                src: '' + embedBaseUrl + videoId + '?' + embedParams,
                title: title || "YouTube video player",
                frameBorder: '0',
                allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
                referrerPolicy: 'strict-origin-when-cross-origin',
                allowFullScreen: true
            })
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'lazy-youtube-frame', style: { aspectRatio: width + ' / ' + height } },
        _react2.default.createElement(
            'button',
            { className: 'lazy-youtube', onClick: handleClick, 'aria-label': 'Play video: ' + title },
            _react2.default.createElement(_Picture2.default, {
                src: coverImage,
                alt: title || "Video thumbnail",
                className: 'lazy-youtube-cover'
            })
        )
    );
};

exports.default = LazyYouTube;

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _LazyYouTube = __webpack_require__(580);

var _LazyYouTube2 = _interopRequireDefault(_LazyYouTube);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(595);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var aiTestimonialsData = [{
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"Acabei seguindo o mesmo processo que usava ao adicionar por planilha, porque \xE9 mais c\xF4modo. O mais incr\xEDvel \xE9 que a ferramenta permite alterar a quantidade de uma refer\xEAncia, caso esteja errada, j\xE1 no momento da importa\xE7\xE3o, sem precisar ficar ajustando a planilha v\xE1rias vezes. ',
        _react2.default.createElement(
            'b',
            null,
            'Simplesmente perfeito!'
        ),
        '"'
    ),
    author: "Kaio Azevedo",
    company: "WKF Representações",
    stars: 5
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"Bem legal! Otimiza bastante o tempo para as empresas que recebem muitos pedidos pelo WhatsApp e perdem tempo criando tudo manualmente. Com a IA, \xE9 s\xF3 copiar e colar a mensagem e, se for necess\xE1rio, ajustar algum item. ',
        _react2.default.createElement(
            'b',
            null,
            '\xC9 r\xE1pido, simples e muito eficiente.'
        ),
        '"'
    ),
    author: "Eduardo Woiciechoski",
    company: "WB Distribuidora",
    stars: 5
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"',
        _react2.default.createElement(
            'b',
            null,
            'Tem sido bem \xFAtil mesmo!'
        ),
        ' O que mais notei de diferen\xE7a foi o tempo que tenho economizado. Antes eu ficava muito tempo fazendo pedidos que recebo por e-mail ou whatsapp manualmente, tendo que colocar n\xFAmero exato de cada produto, e agora com a IA isso ficou muito mais r\xE1pido.'
    ),
    author: "Bruno Barbosa",
    company: "Barbosa & Colombi",
    stars: 5
}];

var homeTestimonialsData = [{
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        'Faz\xEDamos v\xE1rias reuni\xF5es presenciais com grandes contas e precis\xE1vamos registrar rapidamente pedidos com muitos itens, em grandes quantidades. Lev\xE1vamos bastante tempo para concluir tudo. Hoje, com o Pedidos com IA, a emiss\xE3o ficou muito mais \xE1gil. O Mercos tem uma tecnologia que realmente facilita nosso dia a dia.'
    ),
    author: "Jéssica Araujo",
    company: "Océane",
    stars: 5,
    img: "jessica-araujo",
    imgAlt: "Jéssica Araujo, Océane"
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        'A facilidade do cliente fazer os pedidos conosco foi o principal ponto. Ficamos extremamente felizes em saber que nossos clientes, gostam, se adaptam bem e n\xE3o t\xEAm dificuldades. \xC9 tudo muito simples, interativo e f\xE1cil de usar. O sistema \xE9 muito completo e facilita muito a nossa vida!'
    ),
    author: "Alessandro Gonçalves",
    company: "Diretor Comercial da Mels Brushes",
    stars: 5,
    img: "alessandro-goncalves",
    imgAlt: "Alessandro Gonçalves, Diretor Comercial da Mels Brushes"
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'b',
            null,
            'Aumento de 20% do faturamento com o e-commerce B2B'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        'Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.'
    ),
    author: "Henrique Zompeiro",
    company: "Gerente Financeiro na CorsaBIke",
    stars: 5,
    img: "henrique-zompeiro",
    imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike"
}];

var TestimonialVideoCards = function (_Component) {
    _inherits(TestimonialVideoCards, _Component);

    function TestimonialVideoCards(props) {
        _classCallCheck(this, TestimonialVideoCards);

        return _possibleConstructorReturn(this, (TestimonialVideoCards.__proto__ || Object.getPrototypeOf(TestimonialVideoCards)).call(this, props));
    }

    _createClass(TestimonialVideoCards, [{
        key: 'getTestimonials',
        value: function getTestimonials() {
            var testimonialList = {
                joseDavidCopelman: {
                    img: "jose-david-copelman",
                    imgAlt: "José David Copelman, Gestor Nacional de Vendas na CROWN",
                    title: "Crescimento de 12% em vendas em 2023",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Antes do Mercos, eram 3 pessoas exclusivas para lan\xE7ar pedidos. Hoje com os dois sistemas integrados, ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'ganhamos controle e efici\xEAncia em nossa opera\xE7\xE3o'
                        ),
                        '.'
                    ),
                    author: "José David Copelman",
                    company: "Gestor Nacional de Vendas na CROWN"
                },
                leandroCampos: {
                    img: "leandro-campos",
                    imgAlt: "Leandro Campos, Gestor Comercial e Marketing na Tagima",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Nossos clientes t\xEAm uma primeira experi\xEAncia positiva, pois o E-commerce B2B \xE9 t\xE3o intuitivo e f\xE1cil de usar quanto o For\xE7a de vendas. O principal ganho foi a velocidade na tratativa de pedidos. Agora, conseguimos processar mais notas por dia e, at\xE9 mesmo, integrar estoque.'
                    ),
                    author: "Leandro Campos",
                    company: "Gestor Comercial e Marketing na Tagima"
                },
                henriqueZompeiroOld: {
                    img: "henrique-zompeiro",
                    imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike",
                    title: "Aumento de 20% do faturamento com o e-commerce B2B",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.'
                    ),
                    author: "Henrique Zompeiro",
                    company: "Gerente Financeiro na CorsaBike",
                    className: "desktop-only"
                },
                allanGomes: {
                    img: "allan-gomes",
                    imgAlt: "Allan Gomes, Sócio proprietário da La Ganexa",
                    title: "O Mercos economizou 2 dias de trabalho mensal que tínhamos antes",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Al\xE9m de trazer economia de tempo e efici\xEAncia para o nosso processo, tamb\xE9m trouxe mais dinheiro para a La Ganexa.'
                    ),
                    author: "Allan Gomes",
                    company: "Sócio proprietário da La Ganexa"
                },
                felipeAlmeida: {
                    img: "felipe-almeida",
                    imgAlt: "Felipe Almeida, HPrime",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Hoje, os vendedores est\xE3o muito mais focados na rela\xE7\xE3o com o cliente e em serem especialistas que ajudam na venda e no p\xF3s-venda do que em resolver as min\xFAcias burocr\xE1ticas de uma tabela, por exemplo'
                    ),
                    author: "Felipe Almeida",
                    company: "HPrime"
                },
                alexandreSantos: {
                    img: "alexandre-santos-delicia-lanches",
                    imgAlt: "Alexandre Santos, Delícia Lanches",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e \xE0s tend\xEAncias. N\xE3o tem jeito, quem n\xE3o faz isso perde grandes oportunidades.'
                    ),
                    author: "Alexandre Santos",
                    company: "Delícia Lanches",
                    className: "desktop-only"
                },
                francielMartins: {
                    img: "franciel-martins",
                    imgAlt: "Franciel Martins",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O Mercos transformou completamente nossa opera\xE7\xE3o de vendas. A facilidade de uso e a integra\xE7\xE3o com nossos sistemas existentes nos permitiu aumentar significativamente nossa produtividade.'
                    ),
                    author: "Franciel Martins",
                    company: "Empresa Demo"
                },
                francielMartins2: {
                    img: "franciel",
                    imgAlt: "Franciel Martins, ZT Representações",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O Mercos pra gente foi um divisor de \xE1guas na quest\xE3o da opera\xE7\xE3o. Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera e monta os pedidos.'
                    ),
                    author: "Franciel Martins",
                    company: "ZT Representações"
                },
                joaoDePauloOliveira: {
                    img: "joao-paulo-oliveira",
                    imgAlt: "João de Paulo Oliveira, Gao Cosméticos",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Eu pesquisei solu\xE7\xF5es de mercado e decidi contratar Mercos porque a ferramenta al\xE9m de ser f\xE1cil de usar, me oferece tr\xEAs recursos que meu neg\xF3cio precisa: e-commerce B2B, for\xE7a de vendas e indicadores gerenciais'
                    ),
                    author: "João de Paulo Oliveira",
                    company: "Gao Cosméticos"
                }
            };

            // Return testimonials based on props
            if (this.props.tpPage) {
                return [testimonialList.francielMartins2, testimonialList.felipeAlmeida, testimonialList.joaoDePauloOliveira];
            }

            return [testimonialList.leandroCampos, testimonialList.felipeAlmeida, testimonialList.alexandreSantos];
        }
    }, {
        key: 'defaultTestimonials',
        value: function defaultTestimonials() {
            var _props = this.props,
                isAI = _props.isAI,
                isHome = _props.isHome,
                sectionTitle = _props.title,
                descriptionH4 = _props.descriptionH4,
                isAIPage = _props.isAIPage,
                noVideo = _props.noVideo,
                tpPage = _props.tpPage,
                customTestimonialsProp = _props.customTestimonials,
                isDistributor = _props.isDistributor;
            // Prefer explicit customTestimonials passed via props (page-specific overrides)

            var baseTestimonials = isAI ? aiTestimonialsData : isHome ? homeTestimonialsData : [];
            var customTestimonials = Array.isArray(customTestimonialsProp) && customTestimonialsProp.length > 0 ? customTestimonialsProp : tpPage ? this.getTestimonials() : [];
            var testimonialsToRender = customTestimonials.length > 0 ? customTestimonials : baseTestimonials;

            var TitleComponent = isAIPage ? 'h3' : 'h3';
            var containerClass = isDistributor ? 'static-testimonials static-testimonials-distributor' : 'static-testimonials static-testimonials-b2b';

            return _react2.default.createElement(
                'div',
                { className: containerClass },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-title ' + (sectionTitle ? 'testimonials-title-picture-second-title' : '') },
                    _react2.default.createElement(
                        'div',
                        { className: 'testimonials-title-slider-btns' },
                        sectionTitle ? _react2.default.createElement(
                            TitleComponent,
                            { className: 'title' },
                            sectionTitle
                        ) : ''
                    )
                ),
                !noVideo && _react2.default.createElement(
                    'div',
                    { className: 'testimonials-videos' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        isAIPage ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/hg8RE2ebBKw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/GbkxUaWZYJw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/oBLU1_LOL3A', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        ) : isAI ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/hg8RE2ebBKw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/GbkxUaWZYJw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/oBLU1_LOL3A', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        ) : isHome ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: '6qEule4v-b8', coverImage: '/images/site/depoimentos/alessandro-vertical-video.png', title: 'Depoimento Alessandro' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: 'kF5GQkz6J6w', coverImage: '/images/site/depoimentos/bruno-vertical-video.png', title: 'Depoimento Bruno' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: '9Z2o648HcBw', coverImage: '/images/site/depoimentos/rafael-vertical-video.png', title: 'Depoimento Rafael' })
                            )
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/FHnSkFs8Xmg?si=Nuatrl8SzhFXIDbK&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop-only' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/eFgUXUQdq2M?si=TaKxCao1DPTKKGXa&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/6qEule4v-b8?si=6TnmqyVB8SGDlz-t&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        )
                    )
                ),
                testimonialsToRender && testimonialsToRender.length > 0 ? _react2.default.createElement(
                    'div',
                    { className: 'testimonial-cards-container' },
                    testimonialsToRender.map(function (testimonial, index) {
                        return _react2.default.createElement(
                            'div',
                            { key: index, className: 'testimonial-card ' + (testimonial.className || '') },
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-head' },
                                testimonial.categoryIcon ? _react2.default.createElement(
                                    'div',
                                    { className: 'testimonial-category-badge' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'category-icon' },
                                        _react2.default.createElement(_Picture2.default, { src: testimonial.categoryIcon, alt: '' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'testimonial-category-text' },
                                        testimonial.categoryText
                                    )
                                ) : _react2.default.createElement(
                                    'span',
                                    { className: 'testimonial-card-stars' },
                                    '★'.repeat(testimonial.stars || 5)
                                )
                            ),
                            testimonial.title && _react2.default.createElement(
                                'p',
                                { className: 'testimonial-card-title' },
                                testimonial.title
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'testimonial-card-paragraph' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-header' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'testimonial-card-author-company' },
                                    testimonial.img && _react2.default.createElement(_Picture2.default, { className: 'profile-image', alt: testimonial.imgAlt, width: '50', src: '/images/site/depoimentos/' + testimonial.img + '.png' }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'testimonial-author-wrapper' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'testimonial-card-author' },
                                            testimonial.author
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'testimonial-card-company' },
                                            testimonial.company
                                        )
                                    )
                                )
                            )
                        );
                    })
                ) : null
            );
        }
    }, {
        key: 'repsTestimonials',
        value: function repsTestimonials() {
            return _react2.default.createElement(
                'div',
                { className: 'static-testimonials' },
                'Reps Testimonials (Not Implemented with AI prop yet)'
            );
        }
    }, {
        key: 'blacknovTestimonials',
        value: function blacknovTestimonials() {
            return _react2.default.createElement(
                'div',
                { className: 'static-testimonials' },
                'Black November Testimonials (Not Implemented with AI prop yet)'
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.reps ? this.repsTestimonials() : this.props.blackNovember ? this.blacknovTestimonials() : this.defaultTestimonials()
            );
        }
    }]);

    return TestimonialVideoCards;
}(_react.Component);

exports.default = TestimonialVideoCards;

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _constants = __webpack_require__(555);

__webpack_require__(622);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroRatings = function HeroRatings(_ref) {
  var _ref$hideGoogleMyBusi = _ref.hideGoogleMyBusiness,
      hideGoogleMyBusiness = _ref$hideGoogleMyBusi === undefined ? false : _ref$hideGoogleMyBusi,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === undefined ? false : _ref$showTitle,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === undefined ? false : _ref$noMargin,
      _ref$noWrapper = _ref.noWrapper,
      noWrapper = _ref$noWrapper === undefined ? false : _ref$noWrapper;

  var content = _react2.default.createElement(
    _react2.default.Fragment,
    null,
    showTitle && _react2.default.createElement(
      'p',
      { className: 'ia-hero-ratings-title' },
      'O Aplicativo mais bem avaliado do mercado:'
    ),
    _react2.default.createElement(
      'div',
      { className: 'ia-hero-ratings' },
      _react2.default.createElement(
        'div',
        { className: 'ia-rating-card' },
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-info' },
          _react2.default.createElement(
            'div',
            { className: 'ia-rating-score' },
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-value' },
              _constants.SITE_CONSTANTS.GOOGLE_PLAY_RATING
            ),
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-star-char' },
              '\u2605'
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'ia-rating-reviews-text' },
            _constants.SITE_CONSTANTS.GOOGLE_PLAY_REVIEWS
          )
        ),
        _react2.default.createElement(_Picture2.default, { className: 'ia-rating-platform-logo', alt: 'Google Play Logo', src: '/images/site/recursos/google-play.png' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'ia-rating-card' },
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-info' },
          _react2.default.createElement(
            'div',
            { className: 'ia-rating-score' },
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-value' },
              _constants.SITE_CONSTANTS.APP_STORE_RATING
            ),
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-star-char' },
              '\u2605'
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'ia-rating-reviews-text' },
            _constants.SITE_CONSTANTS.APP_STORE_REVIEWS
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-platform-appstore' },
          _react2.default.createElement(_Picture2.default, { className: 'ia-rating-platform-logo', alt: 'Apple Logo', src: '/images/site/recursos/app-store.png' })
        )
      ),
      !hideGoogleMyBusiness && _react2.default.createElement(
        'div',
        { className: 'ia-rating-card' },
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-info' },
          _react2.default.createElement(
            'div',
            { className: 'ia-rating-score' },
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-value' },
              _constants.SITE_CONSTANTS.GOOGLE_BUSINESS_RATING
            ),
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-star-char' },
              '\u2605'
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'ia-rating-reviews-text' },
            _constants.SITE_CONSTANTS.GOOGLE_BUSINESS_REVIEWS
          )
        ),
        _react2.default.createElement(_Picture2.default, { className: 'ia-rating-platform-logo', alt: 'Google Meu Neg\xF3cio Logo', src: '/images/site/recursos/google-meu-negocio.png' })
      )
    )
  );

  if (noWrapper) {
    return content;
  }

  return _react2.default.createElement(
    'div',
    { className: 'ia-hero-ratings-wrapper ' + (noMargin ? 'no-margin' : '') },
    content
  );
};

exports.default = HeroRatings;

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SiteNav = __webpack_require__(547);

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SiteNav2.default;

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _DemoFormB2B = __webpack_require__(554);

var _DemoFormB2B2 = _interopRequireDefault(_DemoFormB2B);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

__webpack_require__(738);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromoBannerCTA = function PromoBannerCTA(_ref) {
  var headline = _ref.headline,
      _ref$subtexts = _ref.subtexts,
      subtexts = _ref$subtexts === undefined ? [] : _ref$subtexts,
      _ref$primaryButtonTex = _ref.primaryButtonText,
      primaryButtonText = _ref$primaryButtonTex === undefined ? "teste grátis" : _ref$primaryButtonTex,
      _ref$isEcommerce = _ref.isEcommerce,
      isEcommerce = _ref$isEcommerce === undefined ? false : _ref$isEcommerce,
      _ref$isReps = _ref.isReps,
      isReps = _ref$isReps === undefined ? false : _ref$isReps,
      _ref$ctaBtn = _ref.ctaBtn,
      ctaBtn = _ref$ctaBtn === undefined ? null : _ref$ctaBtn,
      _ref$modalLink = _ref.modalLink,
      modalLink = _ref$modalLink === undefined ? false : _ref$modalLink,
      _ref$inlineBtns = _ref.inlineBtns,
      inlineBtns = _ref$inlineBtns === undefined ? true : _ref$inlineBtns,
      _ref$darkBg = _ref.darkBg,
      darkBg = _ref$darkBg === undefined ? false : _ref$darkBg,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === undefined ? "promo-banner-cta-container" : _ref$containerClassNa,
      _ref$bannerClassName = _ref.bannerClassName,
      bannerClassName = _ref$bannerClassName === undefined ? "promo-banner-cta" : _ref$bannerClassName,
      isAIPage = _ref.isAIPage;

  var HeadlineComponent = isAIPage ? 'h4' : 'h2';
  return _react2.default.createElement(
    'div',
    { className: containerClassName },
    _react2.default.createElement(
      'div',
      { className: bannerClassName },
      _react2.default.createElement(
        'div',
        { className: 'promo-banner-content' },
        headline && _react2.default.createElement(
          HeadlineComponent,
          { className: 'promo-banner-headline' },
          headline
        ),
        _react2.default.createElement(
          'div',
          { className: 'promo-banner-actions' },
          isEcommerce ? _react2.default.createElement(
            _DemoFormB2B2.default,
            null,
            primaryButtonText
          ) : ctaBtn ? ctaBtn : isReps ? _react2.default.createElement(_DemoForm2.default, { darkBg: darkBg }) : _react2.default.createElement(_DemoForm2.default, {
            trialAndDemo: primaryButtonText,
            darkBg: darkBg,
            ctaText: true // This prop enables the demo button in DemoForm
            , modalLink: modalLink,
            inlineBtns: inlineBtns,
            showOr: false // No "OR" text needed between buttons for this design
            , modalSmall: false
          })
        )
      )
    )
  );
}; // For conditional classes if needed

PromoBannerCTA.propTypes = {
  headline: _propTypes2.default.node.isRequired,
  subtexts: _propTypes2.default.arrayOf(_propTypes2.default.string),
  primaryButtonText: _propTypes2.default.string,
  isEcommerce: _propTypes2.default.bool,
  isReps: _propTypes2.default.bool,
  ctaBtn: _propTypes2.default.node,
  modalLink: _propTypes2.default.bool,
  inlineBtns: _propTypes2.default.bool,
  darkBg: _propTypes2.default.bool,
  containerClassName: _propTypes2.default.string,
  bannerClassName: _propTypes2.default.string
};

exports.default = PromoBannerCTA;

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(740);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwoColumnAccordionWithImage = function TwoColumnAccordionWithImage(_ref) {
  var mainTitleRegular = _ref.mainTitleRegular,
      mainTitleBold = _ref.mainTitleBold,
      titleGraphicSrc = _ref.titleGraphicSrc,
      titleGraphicAlt = _ref.titleGraphicAlt,
      features = _ref.features,
      mainImageSrc = _ref.mainImageSrc,
      mainImageAlt = _ref.mainImageAlt,
      isAIPage = _ref.isAIPage;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var onItemClick = function onItemClick(index) {
    setActiveIndex(activeIndex === index ? null : index);
  };

  var currentImageSrc = mainImageSrc;
  var currentImageAlt = mainImageAlt;

  if (activeIndex !== null && features[activeIndex] && features[activeIndex].imageSrc) {
    currentImageSrc = features[activeIndex].imageSrc;
    currentImageAlt = features[activeIndex].imageAlt || features[activeIndex].title || mainImageAlt;
  }

  var MainTitleComponent = isAIPage ? 'h3' : 'h3';
  var FeatureTitleComponent = isAIPage ? 'p' : 'h4';

  return _react2.default.createElement(
    'section',
    { className: 'two-cols-accordion-section container' },
    _react2.default.createElement(
      'div',
      { className: 'two-cols-accordion-title-wrapper' },
      _react2.default.createElement(
        MainTitleComponent,
        { className: 'two-cols-accordion-main-title' },
        mainTitleRegular && _react2.default.createElement(
          'span',
          { className: 'two-cols-accordion-title-regular' },
          mainTitleRegular,
          ' '
        ),
        mainTitleBold && _react2.default.createElement(
          'span',
          { className: 'two-cols-accordion-title-bold' },
          mainTitleBold
        )
      ),
      titleGraphicSrc && _react2.default.createElement(_Picture2.default, {
        className: 'two-cols-accordion-title-graphic',
        alt: titleGraphicAlt || 'Decorative graphic',
        src: titleGraphicSrc
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'two-cols-accordion-content-wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'two-cols-accordion-features-list' },
        features && features.map(function (feature, index) {
          return _react2.default.createElement(
            'div',
            {
              key: feature.id || index,
              className: 'two-cols-accordion-feature-item-detailed'
            },
            _react2.default.createElement(
              'div',
              {
                className: 'two-cols-accordion-feature-item-header',
                onClick: function onClick() {
                  return onItemClick(index);
                },
                onKeyDown: function onKeyDown(e) {
                  return e.key === 'Enter' && onItemClick(index);
                },
                role: 'button',
                tabIndex: 0,
                'aria-expanded': activeIndex === index,
                'aria-controls': 'feature-desc-' + (feature.id || index)
              },
              _react2.default.createElement(
                'div',
                { className: 'two-cols-accordion-feature-icon-title-wrapper' },
                feature.iconSrc && _react2.default.createElement(
                  'div',
                  { className: 'two-cols-accordion-feature-icon-container' },
                  _react2.default.createElement(_Picture2.default, {
                    className: 'two-cols-accordion-feature-icon',
                    alt: feature.iconAlt || 'Feature icon',
                    src: feature.iconSrc
                  })
                ),
                _react2.default.createElement(
                  FeatureTitleComponent,
                  { className: 'two-cols-accordion-feature-item-title' },
                  feature.title
                )
              ),
              feature.arrowSrc && _react2.default.createElement(_Picture2.default, {
                className: 'two-cols-accordion-feature-arrow ' + (activeIndex === index ? 'expanded' : ''),
                alt: feature.arrowAlt || 'Ver mais / menos',
                src: feature.arrowSrc
              })
            ),
            feature.description && _react2.default.createElement(
              'div',
              {
                id: 'feature-desc-' + (feature.id || index),
                className: 'two-cols-accordion-feature-item-description ' + (activeIndex === index ? 'expanded' : '')
              },
              _react2.default.createElement(
                'p',
                null,
                feature.description
              )
            ),
            _react2.default.createElement('hr', { className: 'two-cols-accordion-feature-item-divider' })
          );
        })
      ),
      currentImageSrc && _react2.default.createElement(
        'div',
        { className: 'two-cols-accordion-image-container' },
        _react2.default.createElement(_Picture2.default, {
          className: 'two-cols-accordion-image',
          alt: currentImageAlt || 'Section image',
          src: currentImageSrc
        })
      )
    )
  );
};

exports.default = TwoColumnAccordionWithImage;

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(742);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericFAQ = function GenericFAQ(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "Perguntas frequentes" : _ref$title,
      _ref$faqItems = _ref.faqItems,
      faqItems = _ref$faqItems === undefined ? [] : _ref$faqItems,
      _ref$defaultOpenIndex = _ref.defaultOpenIndex,
      defaultOpenIndex = _ref$defaultOpenIndex === undefined ? null : _ref$defaultOpenIndex,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === undefined ? "generic-faq-container" : _ref$containerClassNa,
      _ref$itemClassName = _ref.itemClassName,
      itemClassName = _ref$itemClassName === undefined ? "generic-faq-item" : _ref$itemClassName,
      _ref$questionClassNam = _ref.questionClassName,
      questionClassName = _ref$questionClassNam === undefined ? "generic-faq-question" : _ref$questionClassNam,
      _ref$answerClassName = _ref.answerClassName,
      answerClassName = _ref$answerClassName === undefined ? "generic-faq-answer" : _ref$answerClassName,
      _ref$arrowIconSrc = _ref.arrowIconSrc,
      arrowIconSrc = _ref$arrowIconSrc === undefined ? "/images/site/recursos/arrow-down.svg" : _ref$arrowIconSrc,
      _ref$headerLightbulbI = _ref.headerLightbulbIconSrc,
      headerLightbulbIconSrc = _ref$headerLightbulbI === undefined ? "/images/site/recursos/pedidos-ia/faq-lightbulb.png" : _ref$headerLightbulbI,
      isAIPage = _ref.isAIPage;

  var _useState = (0, _react.useState)(defaultOpenIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var toggleAccordion = function toggleAccordion(index) {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (!faqItems || faqItems.length === 0) {
    return null;
  }

  var TitleComponent = isAIPage ? 'p' : 'h2';

  return _react2.default.createElement(
    'div',
    { className: containerClassName },
    _react2.default.createElement(
      'div',
      { className: 'generic-faq-header' },
      _react2.default.createElement(
        'div',
        { className: 'generic-faq-title-wrapper' },
        _react2.default.createElement(
          TitleComponent,
          { className: 'generic-faq-title' },
          title
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'generic-faq-header-icon-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'generic-faq-header-icon-overlap' },
          _react2.default.createElement('div', { className: 'generic-faq-header-icon-ellipse' }),
          headerLightbulbIconSrc ? _react2.default.createElement(_Picture2.default, { className: 'generic-faq-header-icon-image', src: headerLightbulbIconSrc, alt: 'FAQ Icon' }) : _react2.default.createElement(
            'div',
            { className: 'generic-faq-header-icon-text' },
            '\uD83D\uDCA1'
          )
        )
      )
    ),
    faqItems.map(function (item, index) {
      return _react2.default.createElement(
        'div',
        { className: itemClassName, key: index },
        _react2.default.createElement('div', { className: 'generic-faq-divider' }),
        _react2.default.createElement(
          'button',
          {
            className: questionClassName + ' ' + (activeIndex === index ? 'active' : ''),
            onClick: function onClick() {
              return toggleAccordion(index);
            },
            'aria-expanded': activeIndex === index,
            'aria-controls': 'faq-answer-' + index
          },
          _react2.default.createElement(
            'span',
            { className: 'generic-faq-question-text' },
            item.question
          ),
          _react2.default.createElement(_Picture2.default, {
            className: 'generic-faq-arrow-icon',
            alt: 'Expandir/recolher',
            src: arrowIconSrc
          })
        ),
        _react2.default.createElement(
          'div',
          {
            id: 'faq-answer-' + index,
            className: answerClassName + ' ' + (activeIndex === index ? 'active' : '')
          },
          typeof item.answer === 'string' ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: item.answer } }) : item.answer
        )
      );
    })
  );
};

exports.default = GenericFAQ;

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(555);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(744);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrustedByCompanies = function TrustedByCompanies(_ref) {
  var isAIPage = _ref.isAIPage;


  var logos = [{ src: "/images/site/customers/mtx.png", alt: "MTX logo" }, { src: "/images/site/customers/tagima.png", alt: "Tagima logo" }, { src: "/images/site/customers/mili.png", alt: "Mili logo" }, { src: "/images/site/customers/berwanger.png", alt: "Berwanger logo" }, { src: "/images/site/customers/anasol-cor.png", alt: "Anasol logo" }, { src: "/images/site/customers/gelopar.png", alt: "Gelopar logo" }, { src: "/images/site/customers/hprime.png", alt: "HPrime logo" }];

  var TitleComponent = isAIPage ? 'p' : 'h3';

  return _react2.default.createElement(
    'div',
    { className: 'trusted-by-companies-section' },
    _react2.default.createElement(
      TitleComponent,
      { className: 'trusted-by-title' },
      _react2.default.createElement(
        'span',
        { className: 'trusted-by-text-bold' },
        _constants.SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS,
        ' empresas'
      ),
      _react2.default.createElement(
        'span',
        { className: 'trusted-by-text-regular' },
        ' confiam na Mercos'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'trusted-by-logos-grid' },
      logos.map(function (logo, index) {
        return _react2.default.createElement(
          'div',
          { className: 'trusted-by-logo-item', key: index },
          _react2.default.createElement(_Picture2.default, { src: logo.src, alt: logo.alt, className: 'trusted-by-logo-image' })
        );
      })
    )
  );
};

exports.default = TrustedByCompanies;

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/recursos/SistemaDePedidosComIA.jsx.f95dad8d.js